import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { PropertyFilterInterface, PropertyInterface } from '../models/property.model';
import { ApiService } from './api.service';

const route = {
  filter: '/item-type/filter',
  create: '/item-type/create',
  update: '/item-type/update',
  allType: '/item-type/get-all-type-properties',
  getById: (id: string) => `/item-type/get-by-id/${id}`,
  allTypeFeedback: '/item-type/get-all-for-feedback'
}

@Injectable({
  providedIn: 'root'
})
export class AsPropertyService {

  constructor(private apiService: ApiService) { }

// get datatable
  filterData(obj: PropertyFilterInterface) {
    return this.apiService.post(route.filter, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

// create property
  create(obj: PropertyInterface) {
    return this.apiService.post(route.create, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

  // update property
  update(obj: PropertyInterface) {
    return this.apiService.post(route.update, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

  // get property
  getProperty(id: string) {
    return this.apiService.get(route.getById(id)).pipe(
      map(res => {
        return res;
      })
    )
  }


  getAllTypeProperties() {
    return this.apiService.get(route.allType).pipe(
      map(res => {
        return res;
      })
    )
  }

  // get type feedback
  getTypesFeedback() {
    return this.apiService.get(route.allTypeFeedback).pipe(
      map(res => {
        return res;
      })
    )
  }
}
